import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Flex } from 'Components/UI'

import { PADDING_X } from 'Constants/Landing'

export const Container = styled(Flex).attrs({
  pt: [80, 80, 64, 64, 32],
  pb: [80, 80, 100, 100, 120],
  px: PADDING_X,
})`
  width: 100%;
  justify-content: center;
  background-color: ${themeGet('colors.bg.default')};
  position: relative;
  overflow: hidden;
`

export const Content = styled.div`
  width: 100%;
`
